import ReportPage from './ReportPage'

export default function CuponsReport({className = ''}: {className?: string}) {
  return <ReportPage type='cupons' className={className} />
}
